import {
    LoginByTemporaryPasswordRequestData,
    LoginByTemporaryPasswordResponse,
    LoginGetPasswordRequestData,
    LoginGetPasswordResponse,
} from './login-types';
import { authApi } from '@shared/api/base/auth-base';
import { API_PATH_LOGIN_BY_TEMPORARY_PASSWORD, API_PATH_TEMPORARY_PASSWORD } from '@shared/config/api/api-paths';
import { API_AUTH_PREFIX } from '@shared/config/api/api-prefixes';
import { setCredentials } from '@shared/lib/utils/credentials/credentials';

export const loginApi = authApi.injectEndpoints({
    endpoints: (build) => ({
        requestPassword: build.mutation<LoginGetPasswordResponse, LoginGetPasswordRequestData>({
            query(data) {
                return {
                    url: `${API_AUTH_PREFIX}${API_PATH_TEMPORARY_PASSWORD}`,
                    method: 'POST',
                    body: { ...data },
                };
            },
        }),
        loginByTemporaryPassword: build.mutation<LoginByTemporaryPasswordResponse, LoginByTemporaryPasswordRequestData>(
            {
                query(data) {
                    return {
                        url: `${API_AUTH_PREFIX}${API_PATH_LOGIN_BY_TEMPORARY_PASSWORD}`,
                        method: 'POST',
                        body: { ...data },
                    };
                },
                async onQueryStarted(_, { queryFulfilled }) {
                    try {
                        const { data } = await queryFulfilled;
                        setCredentials({
                            accessToken: data.accessToken,
                            refreshToken: data.refreshToken,
                        });
                    } catch (err) {
                        console.log(err);
                    }
                },
            }
        ),
    }),
});

export const { useLoginByTemporaryPasswordMutation, useRequestPasswordMutation } = loginApi;
